import { Model, fk, many, attr } from "redux-orm";

class DisputeModel extends Model {
  static reducer(action, DisputeModel, session) {
    switch (action.type) {
      case "UPSERT_dispute":
        action.payload.forEach((payload) => {
          const dbData = DisputeModel.withId(payload.id);

          const upsertData = payload;
          if (dbData) {
            const keys = Object.keys(upsertData);
            let needChange = false;
            keys.map((key) => {
              if (
                JSON.stringify(upsertData[key]) !== JSON.stringify(dbData[key])
              ) {
                needChange = true;
              }
            });

            if (!needChange) {
              return;
            }
          }

          DisputeModel.upsert(payload);
        });
        break;
    }
    // Return value is ignored.
    return session.state;
  }

  toString() {
    return this.id;
  }
  // Declare any static or instance methods you need.
}
DisputeModel.modelName = "DisputeModel";

DisputeModel.fields = {
  id: attr(),
};

export default DisputeModel;